import React from 'react';

// chat-menu-icons: one-or-two-stroke outline icons for the side menu. Drawn in
// currentColor so they follow the item's text colour (active, hover, tinted).
const PATHS = {
  stations: <path d="M3 3.5h10v7H7l-3 2.5v-2.5H3z" />,
  network: (
    <>
      <circle cx="8" cy="4" r="1.6" /><circle cx="3.8" cy="12" r="1.6" />
      <circle cx="12.2" cy="12" r="1.6" /><path d="M7.2 5.4 4.6 10.6M8.8 5.4l2.6 5.2" />
    </>
  ),
  messages: <><rect x="2.5" y="4" width="11" height="8" rx="1" /><path d="m3 4.8 5 4 5-4" /></>,
  gallery: <><rect x="2.5" y="3" width="11" height="10" rx="1.5" /><path d="m4.5 11 3-3 2.5 2.5 1.5-1.5" /></>,
  tasks: <path d="M3 4.5h10M3 8h10M3 11.5h6" />,
  task: <path d="m3.5 8.5 3 3 6-7" />,
  scheduled: <><circle cx="8" cy="8" r="5.5" /><path d="M8 5v3l2 1.5" /></>,
  company: <><rect x="3.5" y="2.5" width="9" height="11" rx="1" /><path d="M6.5 13.5v-3h3v3" /></>,
  share: <><path d="M8 2.5v7M5.5 5 8 2.5 10.5 5" /><path d="M3.5 9v4h9V9" /></>,
  subscribe: <path d="m8 2.5 1.7 3.4 3.8.6-2.75 2.65.65 3.75L8 11.1l-3.4 1.8.65-3.75L2.5 6.5l3.8-.6z" />,
  subscribed: <path d="m8 2.5 1.7 3.4 3.8.6-2.75 2.65.65 3.75L8 11.1l-3.4 1.8.65-3.75L2.5 6.5l3.8-.6z" fill="currentColor" />,
  settings: <><path d="M3 5h10M3 11h10" /><circle cx="6" cy="5" r="1.5" /><circle cx="10" cy="11" r="1.5" /></>,
  user: <><circle cx="8" cy="5.5" r="2.5" /><path d="M3 13.5c.8-2.4 2.8-3.5 5-3.5s4.2 1.1 5 3.5" /></>,
  login: <><path d="M10 3h2.5v10H10" /><path d="M6 5l3 3-3 3M9 8H3" /></>,
  logout: <><path d="M6 3H3.5v10H6" /><path d="M9.5 5l3 3-3 3M12.5 8H6.5" /></>,
};

export const NAV_ICON_NAMES = Object.keys(PATHS);

export default function NavIcon({ name }) {
  const shape = PATHS[name];
  if (!shape) return null;
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor"
         strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"
         aria-hidden="true" focusable="false" data-icon={name}
         style={{ display: 'inline-block', flex: '0 0 auto', marginRight: '8px', verticalAlign: '-3px' }}>
      {shape}
    </svg>
  );
}
